import type { TransactionItemDetail } from 'models';
import { useCallback, useMemo } from 'react';
import { Icon, Modal, message } from 'ui';
import { useUpdateTransactionItemMutation } from 'features/transactions';

type P = {
  testimonial: TransactionItemDetail;
};

export const useDeleteTestimonial = ({ testimonial }: P) => {
  const [modal, contextHolder] = Modal.useModal();
  const { mutateAsync: updateTransactionItem } = useUpdateTransactionItemMutation();

  const confirm = useCallback(() => {
    const handleDeleteTestimonial = async () => {
      await updateTransactionItem(
        {
          id: testimonial.id,
          showTextContent: false,
        },
        {
          onError() {
            message.error('Something went wrong. The testimonial couldn’t be deleted.');
          },
          onSuccess() {
            message.success('Testimonial successfully deleted.');
          },
        },
      );
    };

    modal.confirm({
      content: 'This action is irreversible!',
      icon: <Icon color="error" icon="delete-2-line" />,
      okText: 'Delete',
      onOk: handleDeleteTestimonial,
      title: 'Are you sure you want to delete this testimonial?',
      type: 'error',
    });
  }, [modal, testimonial.id, updateTransactionItem]);

  return useMemo(() => ({ confirm, contextHolder }), [confirm, contextHolder]);
};
